var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-widget"},[_c('div',{staticClass:"stats-grid"},_vm._l((_vm.stats),function(item,index){return _c('div',{key:index,staticClass:"stat-item"},[_c('span',{staticClass:"stat-value"},[_vm._v(_vm._s(item.value))]),_vm._v(" "),_c('span',{staticClass:"stat-label"},[_vm._v(_vm._s(item.label))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41054152","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User2/widgets/StatsWidget.vue
// module id = null
// module chunks = 